<template>
  <div v-if="large" class="c-meta-box__row--large">
    <div class="c-meta-box__row-value">
      <slot></slot>
    </div>
    <div class="c-meta-box__row-label">{{label}}</div>
  </div>
  <div class="c-meta-box__row" v-else>
    <div class="c-meta-box__row-label">{{label}}</div>
    <div class="c-meta-box__row-value">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "meta-box-row",
  props: {
    label: {
      type: String
    },
    large: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.c-meta-box__row {
  padding: 1em 2em;
  border-top: 1px solid $colour-nhs-pale-grey;
  display: inline-flex;
  flex-direction: column;
  width: 50%;

  @media (min-width: 768px) {
    width: 100%;
    flex-direction: row;
  }

  &-label,
  &-value {
    font-size: 14px;
  }

  &-label {
    flex: 1;
    color: $colour-nhs-dark-grey;
  }

  &-value {
    flex: 1;
    @media (min-width: 1280px) {
      text-align: right;
    }
    color: #697884;
  }

  &--large {
    padding: 20px 0;
  }
  &--large & {
    &-label {
      // float: none;
      flex: 0;
      order: 2;
      text-align: center;
    }
    &-value {
      // float: none;
      font-size: 44px;
      flex: 0;
      order: 1;
      text-align: center;
      color: #697884;
    }
  }
}
</style>
